import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import {
  FaHome,
  FaBuilding,
  FaIndustry,
  FaInfoCircle,
  FaPhone,
 FaThermometer,
  FaSearch,
  FaOptinMonster,
  FaPhoneAlt,
  FaPhoenixFramework,
} from "react-icons/fa";
import { MdWork } from "react-icons/md";
import logo from "../../assets/Lyros-logo.jpg";
import BackToTop from "../home/BackToTop";
import "./Navbar.css";
import { FaGlobe, FaSection, FaTableCells } from "react-icons/fa6";

const MainNavbar = () => {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  // Auto close navbar and scroll to top when route changes
  useEffect(() => {
    setExpanded(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);

  return (
    <>
      <Navbar
        expanded={expanded}
        expand="lg"
        fixed="top"
        className="navbar-main shadow-sm"
      >
        <Container>
          {/* ===== Logo ===== */}
          <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
            <img
              src={logo}
              alt="Lyros Technologies"
              className="navbar-logo me-2"
            />
          </Navbar.Brand>

          {/* ===== Toggle Button ===== */}
          <Navbar.Toggle
            aria-controls="main-navbar"
            onClick={() => setExpanded(expanded ? false : "expanded")}
          />

          {/* ===== Navigation Links ===== */}
          <Navbar.Collapse id="main-navbar" className="justify-content-end">
            <Nav className="align-items-lg-center text-center text-lg-start">
              
              {/* Home */}
              <Nav.Link as={Link} to="/">
                <FaHome className="navbar-icon" /> Home
              </Nav.Link>

              {/* Business Verticals */}
              <NavDropdown
                title={
                  <>
                    <FaBuilding className="navbar-icon" /> Business Verticals
                  </>
                }
                id="business-verticals"
              >
                <NavDropdown.Item
                  as={Link}
                  to="/verticals/workforce-management"
                >
                  <MdWork className="navbar-icon" /> Workforce Management
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/verticals/global-technology">
                  <FaBuilding className="navbar-icon" /> Global Technology
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/verticals/it-ites">
                  <FaIndustry className="navbar-icon" /> IT & ITES
                </NavDropdown.Item>
             
               <NavDropdown.Item as={Link} to="/verticals/digital-marketing">
                  <FaGlobe className="navbar-icon" />Digital Marketing
                </NavDropdown.Item>
              </NavDropdown>
              

              {/* Industries */}
              <NavDropdown
                title={
                  <>
                    <FaIndustry className="navbar-icon" /> Industries
                  </>
                }
                id="industries"
              >
                <NavDropdown.Item
                  as={Link}
                  to="/industries/education-technology"
                >
                  <FaBuilding className="navbar-icon" /> IT Technology
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/industries/healthcare">
                  <FaIndustry className="navbar-icon" /> Healthcare
                </NavDropdown.Item>
                 <NavDropdown.Item as={Link} to="/industries/business-process-outsourcing">
                  <FaPhoenixFramework className="navbar-icon" /> BPO
                </NavDropdown.Item>
                 <NavDropdown.Item as={Link} to="/industries/telecommunication">
                  <FaTableCells className="navbar-icon" /> Telecommunication
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/industries/software-development"
                >
                  <MdWork className="navbar-icon" /> Software Development
                </NavDropdown.Item>
              </NavDropdown>

              {/* About */}
              <Nav.Link as={Link} to="/aboutus">
                <FaInfoCircle className="navbar-icon" /> About Us
              </Nav.Link>
                   <Nav.Link as={Link} to="/careers">
                <FaSearch className="navbar-icon" /> Careers
              </Nav.Link>

              {/* Contact */}
              <Nav.Link as={Link} to="/contact">
                <FaPhoneAlt className="navbar-icon" /> Contact Us
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Back-to-top button */}
      <BackToTop />
    </>
  );
};

export default MainNavbar;
